import React, { useEffect, useRef, useState } from "react";
import PerfectScrollbar from "perfect-scrollbar";
import DataTable from "react-data-table-component";
import { Plus, X, FileText, Map, Info } from "react-feather";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import api from "../Api";

function WorkGroup() {
  const containerRef = useRef(null);
  const tableRef = useRef(null);
  const [workGroups, setWorkGroups] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    region: "",
    description: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post("/work-groups", formData);
      console.log("Work Group berhasil dibuat:", res.data);
      toast.success("Work Group berhasil disimpan!");
      setFormData({ name: "", region: "", description: "" });
      fetchWorkGroups(); // refresh list
    } catch (err) {
      console.error("Gagal membuat Work Group:", err.response || err);
      toast.error("Gagal menyimpan Work Group!");
    }
  };

  const fetchWorkGroups = async () => {
    try {
      const res = await api.get("/work-groups");
      const list = Array.isArray(res.data) ? res.data : [res.data];
      setWorkGroups(list);
    } catch (err) {
      console.error("Gagal fetch work groups:", err.response || err);
    }
  };

  useEffect(() => {
    fetchWorkGroups();
  }, []);

  // Definisi kolom DataTable
  const columns = [
    {
      name: "No",
      selector: (row, index) => index + 1,
      width: "60px",
    },
    {
      name: "Nama Grup",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Region",
      selector: (row) => row.region,
    },
    {
      name: "Deskripsi",
      selector: (row) => row.description,
    },
    {
      name: "Action",
      cell: (row) => <button className="btn btn-warning btn-sm">Edit</button>,
      style: { justifyContent: "center" },
    },
  ];

  // init PerfectScrollbar & DataTable
  useEffect(() => {
    let ps;
    if (containerRef.current) {
      ps = new PerfectScrollbar(containerRef.current);
    }
    if (tableRef.current) {
      new DataTable(tableRef.current);
    }
    return () => {
      if (ps) ps.destroy();
    };
  }, []);

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3>Manajemen Work Group</h3>
            <p className="text-subtitle text-muted">
              Kelola data grup kerja dalam sistem.
            </p>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav aria-label="breadcrumb" className="breadcrumb-header">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/Dashboard">Manajemen</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Work Groups
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="mb-0">List Work Group</h4>
            <a
              className="btn btn-primary d-flex align-items-center gap-1"
              data-bs-toggle="modal"
              data-bs-target="#workGroupModal"
            >
              <Plus size={16} /> Tambah
            </a>
          </div>

          {/* Modal Tambah Work Group */}
          <div
            className="modal fade"
            id="workGroupModal"
            tabIndex="-1"
            aria-labelledby="workGroupModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="workGroupModalLabel">
                    Tambah Work Group
                  </h5>
                  <button
                    type="button"
                    className="border-0 bg-transparent"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <X size={24} strokeWidth={2} />
                  </button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3 mb-4">
                      <div className="col-md-6">
                        <label className="form-label">Nama Grup</label>
                        <div className="form-group position-relative has-icon-left">
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Nama Grup"
                            value={formData.name}
                            onChange={handleChange}
                          />
                          <div className="form-control-icon">
                            <FileText size={16} />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Region</label>
                        <div className="form-group position-relative has-icon-left">
                          <input
                            type="text"
                            name="region"
                            className="form-control"
                            placeholder="Region"
                            value={formData.region}
                            onChange={handleChange}
                          />
                          <div className="form-control-icon">
                            <Map size={16} />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <label className="form-label">Deskripsi</label>
                        <div className="form-group position-relative has-icon-left">
                          <textarea
                            name="description"
                            className="form-control"
                            placeholder="Deskripsi Grup Kerja"
                            value={formData.description}
                            onChange={handleChange}
                          />
                          <div className="form-control-icon">
                            <Info size={16} />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Batal
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Simpan
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* Tabel Work Group */}
          <div className="card-body">
            <DataTable
              columns={columns}
              data={workGroups}
              pagination
              highlightOnHover
              striped
              responsive
            />
          </div>
        </div>
      </section>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default WorkGroup;
